import React from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import InfoCardItem from '../../../molecules/system/infoCardItem/InfoCardItem';

export const InfoCards = ({ section, openModalForm }) => (
  <div className="flex w-full flex-col flex-1 px-8 lg:mx-auto mt-20 md:mt-40 mb-10 mt:mb-20 max-w-5xl">
    <div className="flex flex-col flex-1 justify-center gap-10 py-5">
      <Typography as="h2" fontVariant="h4" className="max-w-md self-center">
        {section.title}
      </Typography>
      {section.componentData.map((item) => (
        <InfoCardItem key={item.id} data={item} />
      ))}
      <LinkButton
        textTransform="uppercase"
        variant="primary-filled"
        label={section.buttonText}
        size="lg"
        className="w-fit self-center mt-10"
        onClick={openModalForm}
      />
    </div>
  </div>
);
